'use client'

// THEME COMPLIANCE: All UI implementations must support both dark and light themes.

import TopHeader from './header/TopHeader'
import { shouldRouteUseNarrowAsMobile, useDevice } from '@/lib/context/DeviceProvider'
import { usePathname } from 'next/navigation'

export default function EnhancedNavigation() {
  const pathname = usePathname()
  const { isHydrated, isMobile, viewportWidth } = useDevice()

  const effectiveMobile = isMobile || shouldRouteUseNarrowAsMobile(pathname, viewportWidth)
  if (!isHydrated) {
    return null
  }

  // On mobile the header is owned by MobileLayout (the full-height mobile shell),
  // which renders MobileNavigation itself. Rendering it here too produced a
  // duplicate header and pushed the h-dvh shell's bottom nav off-screen, so the
  // global nav tree intentionally renders nothing on mobile.
  if (effectiveMobile) {
    return null
  }

  return (
    <>
      {/* Blue nav bar hidden for now; links moved into the header. */}
      <TopHeader />
    </>
  )
}
